<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less"> 
body{
   margin: 0;
   padding:0;
 }
</style>


// WEBPACK FOOTER //
// src/App.vue